module.exports = __webpack_public_path__ + "static/media/icon-enter.efe87ed2.svg";